<mat-form-field class="form-element" appearance="fill">
  <mat-label>material</mat-label>
  <input type="text" placeholder="Search material" matInput [formControl]="materialControl" [matAutocomplete]="auto"
    (focus)="onFocus($event.target.value)" (blur)="updateMaterial($event.target.value)"
    (input)="materialChanges.next($event.target.value)" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setMaterialChangeAction($event)">
    @for (option of materialSuggestions | async; track option) {
      <mat-option [value]="option">
        {{ option }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (materialControl.hasError('noOption')) {
    <mat-error>
      Material not Found
    </mat-error>
  }
</mat-form-field>